/// <amd-module name="Pipeline/Analytics/Common/Telemetry/TelemetryConstants" />
export const area = "PipelineAnalytics";

// Telemetry Features
export const feature_AnalyticsTab = "AnalyticsTab";
export const feature_PipelineAnalyticsFailureCard = "PipelineAnalyticsFailureCard";
export const feature_PipelineAnalyticsFailureHubFilter = "PipelineAnalyticsFailureHubFilter";
export const feature_PipelineAnalyticsOutcomeTrendChart = "OutcomeTrendChart";
export const feature_PipelineAnalyticsTasksFailedTrendChart = "TasksFailedTrendChart";
export const feature_PipelineAnalyticsDurationCard = "PipelineAnalyticsDurationCard";
export const feature_PipelineAnalyticsDurationHubFilter = "PipelineAnalyticsDurationHubFilter";
export const feature_PipelineDurationTrendChart = "PipelineDurationTrendChart";
export const feature_Analytics_PipelineFailures_CardLoaded = "Analytics_PipelineFailures_CardLoaded";
export const feature_Analytics_PipelineDuration_CardLoaded = "Analytics_PipelineDuration_CardLoaded";
export const feature_PipelineAnalyticsLeadTimeCard = "PipelineAnalyticsLeadTimeCard";
export const feature_PipelineAnalyticsLeadTimeCardNotOptedIn = "PipelineAnalyticsLeadTimeCardNotOptedIn";
export const feature_PipelineStepsDurationCard = "PipelineStepsDurationCard";
export const feature_PipelineTaskGrid = "PipelineTaskGrid";

// Telemetry properties
export const ClickCount = "ClickCount";
export const LearnMoreClickCount = "LearnMoreClickCount";
export const PassRate = "PassRate";
export const TaskFailedRate = "TaskFailedRate";
export const TopFailingTask = "TopFailingTask";
export const DateFilterChangedValue = "DateFilterChangedValue";
export const StageFilterChangeCount = "StageFilterChangeCount";
export const BranchCount = "BranchCount";
export const TopFailingTasks = "TopFailingTasks";
export const TasksCount = "TasksCount";
export const TooltipUsageCount = "TooltipUsageCount";
export const LegendClickCount = "LegendClickCount";
export const OutcomeTrendChartData = "OutcomeTrendChartData";
export const TaskDurationPercentage = "TaskDurationPercentage";
export const PercentileDuration = "PercentileDuration(Milliseconds)";
export const DurationTrendChartData = "DurationTrendChartData";
export const RowClick = "RowClick";
export const RowToggle = "RowToggle";
